import React, { useState } from 'react';
import {
  Card,
  CardActionArea,
  CardContent,
  Tooltip,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

import { ISubmissionQuestion } from '../../../../../store/SubmissionSlice';
import QuestionTimeTakenModal from '../../modals/QuestionTimeTakenModal';

type TQuestionTimerProps = {
  selectedQuestion: ISubmissionQuestion;
};

const QuestionTimer: React.FC<TQuestionTimerProps> = ({ selectedQuestion }) => {
  let seconds = 0;
  let min = 0;
  let secs = 0;

  const textColor = '#1E293B';
  const labelStyles: React.CSSProperties = {
    backgroundColor: '#E2E8F0',
    borderRadius: '5px',
  };

  if (selectedQuestion.timerEnd && selectedQuestion.timerStart) {
    seconds = Math.round(
      (selectedQuestion.timerEnd - selectedQuestion.timerStart) / 1000
    );
  }

  const absoluteSeconds = Math.abs(seconds);

  min = Math.floor(absoluteSeconds / 60);
  secs = Math.floor(absoluteSeconds % 60);

  const label = `${min} min ${secs} sec`;

  // State
  const [
    isQuestionTimeTakenModalOpen,
    setQuestionTimeTakenModalOpen,
  ] = useState(false);

  const toggleQuestionTimeTakenModal = () => {
    setQuestionTimeTakenModalOpen((prevState) => !prevState);
  };

  return (
    <>
      <Tooltip title="Time Taken for the Question" placement="bottom">
        <Card elevation={0} style={labelStyles}>
          <CardActionArea onClick={toggleQuestionTimeTakenModal}>
            <CardContent style={{ padding: '5px' }}>
              <Typography
                display="flex"
                alignItems="center"
                textAlign="center"
                variant="subtitle2"
                fontWeight={600}
                color={textColor}
              >
                {label}&nbsp;
                <InfoIcon fontSize="small" style={{ color: textColor }} />
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Tooltip>
      {/* Modals */}
      {isQuestionTimeTakenModalOpen && selectedQuestion && (
        <QuestionTimeTakenModal
          open={isQuestionTimeTakenModalOpen}
          onClose={toggleQuestionTimeTakenModal}
          question={selectedQuestion}
        />
      )}
    </>
  );
};

export default QuestionTimer;
